import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {Campaign} from '../../../../../models/Campaign'

type Props = {
  row: Row<Campaign>
}

const CustomRow: FC<Props> = ({row}) => {
  // console.log(`Campaign Error ${row.id}`)
return (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
    // {console.log("cell =====>>>>"+ JSON.stringify(cell))}
      return (
        <td
          
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
)}

export {CustomRow}
